const requiredHeight = 450;

const getFilterPosition = (btn) => {
    const { top: topSpace, bottom } = btn.getBoundingClientRect();
    const bottomSpace = window.innerHeight - bottom;

    if (bottomSpace > requiredHeight) {
        return 'bottom';
    } else if (topSpace > requiredHeight) {
        return 'top';
    }
    return 'left';
};

export default getFilterPosition;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/helpers/getFilterPosition.js